var _circle, _path, _line;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBelowAvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    transform: "rotate(-180 14 14)",
    fill: "#FF0000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9746 17.1923L17.9737 17.1932L13.9358 21.2477C13.8051 21.3685 13.6233 21.3531 13.5241 21.2539C13.5241 21.2539 13.5241 21.2539 13.5241 21.2539L9.46908 17.1988C9.34787 17.0681 9.36327 16.886 9.4625 16.7868L8.99109 16.3154L9.4625 16.7868C9.52744 16.7218 9.59351 16.6991 9.65688 16.6991C9.70984 16.6991 9.79086 16.7264 9.85127 16.7868L12.2983 19.2338L13.4363 20.3718V18.7623L13.4363 10.639C13.4363 10.4911 13.5707 10.3568 13.7186 10.3568C13.8741 10.3568 14.0008 10.482 14.0008 10.639L14.0008 18.7623V20.3796L15.1405 19.2321L17.5632 16.7928C17.6917 16.6742 17.8696 16.6872 17.9697 16.7819C18.0891 16.9125 18.0734 17.0935 17.9746 17.1923Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.33333
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 19,
    y1: 6.75,
    x2: 8.18741,
    y2: 6.75,
    stroke: "white",
    strokeWidth: 1.5,
    strokeDasharray: "2 2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBelowAvg);
export default __webpack_public_path__ + "static/media/below-avg.8960b6d4eb9f87b1dd512d020fe6ff92.svg";
export { ForwardRef as ReactComponent };